import Request from './request';
import { getHeaders } from './requestHelpers';

const Paths = {
  PAYMENT_ASK: 'askPayment',
  PAYMENT_EXECUTE: 'executePayment',
  PAYMENT_DATACASH_CHECK: 'checkPaymentStatus',
  PAYMENT_AVAILABLE_PAYMENTS: 'listPaymentMethods',
  PAYMENT_CHANGE_DETAILS: 'askChangeBankInformation',
};


/**
 * Returns a list of available payment methods
 * @param {String} params.languageId
 * @return {Promise}
 */
export async function fetchAvailablePayments(params) {
  const { status, result, error } = await Request({
    method: 'POST',
    data: params,
    path: Paths.PAYMENT_AVAILABLE_PAYMENTS,
  });

  return status ? Promise.resolve(result.listPaymentMethods) : Promise.reject(error);
}

/**
 * Ask payment information
 * @param {Object} params
 * @param {Object} params.paymentData
 * @param {string} params.paymentData.paymentBrand - Visa, Mastercard, Paypal.js
 * @param {Number} params.paymentData.paymentProvider - 2 = DATACASH, 10 = PAYPAL
 * @param {boolean} params.paymentData.policyValidation
 * @param {boolean} params.reusePaymentInfo - Backend will reuse previous payment info
 * @param {string} params.voucher - Voucher number
 * @param {String} authToken - user security token
 * @return {Promise}
 */
export async function askPayment(params, authToken) {
  const { status, result, error } = await Request({
    method: 'POST',
    headers: getHeaders(authToken),
    data: params,
    path: Paths.PAYMENT_ASK,
  });

  return status ? Promise.resolve(result) : Promise.reject(error);
}

/**
 * PAYPAL: execute payment and get status
 * @param {Object} params
 * @param {Object} params.paymentData
 * @param {Number} params.paymentData.paymentProvider - 2 = DATACASH, 10 = PAYPAL
 * @param {Object} params.paymentData.paymentParameters
 * @param {String} authToken -  user security token
 * @return {Promise}
 */
export async function executePayment(params, authToken) {
  const { status, result, error } = await Request({
    method: 'POST',
    headers: getHeaders(authToken),
    data: params,
    path: Paths.PAYMENT_EXECUTE,
  });

  return status ? Promise.resolve(result) : Promise.reject(error);
}

/**
 * Fetch a payment status
 * @param {Object} params
 * @param {Object} params.data - ?Transaction number?
 * @param {String} authToken -  user security token
 * @return {Promise}
 */
export async function checkPaymentStatus(params, authToken) {
  const { status, result, error } = await Request({
    method: 'POST',
    headers: getHeaders(authToken),
    data: params,
    path: Paths.PAYMENT_DATACASH_CHECK,
  });

  return status ? Promise.resolve(result) : Promise.reject(error);
}


/**
 * Set default Payment brand
 * @param {Object} params
 * @param {Object} params.paymentData
 * @param {Number} params.paymentData.paymentProvider - 2 = DATACASH, 10 = PAYPAL
 * @param {String} params.paymentData.paymentBrand
 * @param {Boolean} params.paymentData.policyValidation
 * @param {String} authToken -  user security token
 * @return {Promise}
 */
export async function changePaymentDetails(params, authToken) {
  const { status, result, error } = await Request({
    method: 'POST',
    data: params,
    headers: getHeaders(authToken),
    path: Paths.PAYMENT_CHANGE_DETAILS,
  });

  return status ? Promise.resolve(result) : Promise.reject(error);
}
